var samsung_AA59_00600A = {
    name: "AA59_00600A",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [136,0,4,88,2,12,2,88,2,110,6,212,17,126,17,88,2,50,0,42,253,95,223,218,170,137,87,234,254,254,213,84,64],
        },
        {
            function: "KEY_CYCLEWINDOWS",
            name: "KEY_CYCLEWINDOWS",
            icon: "KEY_CYCLEWINDOWS",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,191,234,170,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,239,214,170,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,183,246,170,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,215,238,170,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,247,213,170,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,187,245,170,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,219,237,170,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,235,235,170,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,181,251,170,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,213,247,170,136],
        },
        {
            function: "KEY_102ND",
            name: "KEY_102ND",
            icon: "KEY_102ND",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,175,125,90,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,189,245,106,136],
        },
        {
            function: "KEY_PREVIOUS",
            name: "KEY_PREVIOUS",
            icon: "KEY_PREVIOUS",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,174,253,106,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,171,254,170,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,170,255,170,136],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,221,237,106,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,173,253,170,136],
        },
        {
            function: "KEY_LIST",
            name: "KEY_LIST",
            icon: "KEY_LIST",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,173,175,110,136],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,251,213,106,136],
        },
        {
            // function: "KEY_MEDIA",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,235,213,213,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,218,246,234,136],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,175,250,170,136],
        },
        {
            function: "KEY_OPTION",
            name: "KEY_OPTION",
            icon: "KEY_OPTION",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,173,222,214,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,253,106,174,136],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,170,191,234,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,183,93,174,136],
        },
        {
            function: "KEY_SELECT",
            name: "KEY_SELECT",
            icon: "KEY_SELECT",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,246,181,110,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,222,182,174,136],
        },
        {
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,245,181,118,136],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,190,186,174,136],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,181,189,218,136],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,235,90,238,136],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,237,235,106,136],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,182,251,106,136],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,214,247,106,136],
        },
        {
            function: "KEY_SWITCHVIDEOMODE",
            name: "KEY_SWITCHVIDEOMODE",
            icon: "KEY_SWITCHVIDEOMODE",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,213,93,250,136],
        },
        {
            function: "KEY_LANGUAGE",
            name: "KEY_LANGUAGE",
            icon: "KEY_LANGUAGE",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,255,170,170,136],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,183,123,90,136],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,215,183,86,136],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,183,187,86,136],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,171,223,86,136],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,219,182,214,136],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [68,0,4,88,2,11,2,88,2,109,6,214,17,124,17,88,2,99,183,42,253,95,247,106,214,136],
        },
    ]
}
export default samsung_AA59_00600A